import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import appIcon from '../../assets/iconW.svg';
import cornerBg from '../../assets/murjelm.png';
import { apiFetch } from '../../lib/api';
import './ForgetPassword.css';

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get('token');
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setErrorMsg('');

    if (newPassword !== confirmPassword) {
      setErrorMsg('Passwords do not match');
      return;
    }

    setIsLoading(true);

    try {
      if (resetToken) {
        const result = await apiFetch('/api/auth/reset-password', {
          method: 'POST',
          includeAuth: false,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: resetToken,
            new_password: newPassword,
          }),
        });
        setMessage(result.message || 'Password updated. You can now sign in.');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        const result = await apiFetch('/api/auth/forgot-password', {
          method: 'POST',
          includeAuth: false,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });
        setMessage(result.message || 'If an active account matches this email, a reset link has been sent.');
        setEmail('');
      }
    } catch (error) {
      setErrorMsg(error.message || 'Unable to connect to the authentication server');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-page-wrapper">
      <img src={cornerBg} alt="Background decoration" className="corner-image" />
      <div className="forgot-container">
        <img src={appIcon} alt="App icon" className="app-logo" onClick={() => navigate('/')} />
        <h1>Reset Password</h1>

        <form className="forgot-form" onSubmit={handleResetPassword}>
          {!resetToken ? (
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          ) : (
            <>
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                minLength="6"
                maxLength="72"
                required
              />
              <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                minLength="6"
                maxLength="72"
                required
              />
            </>
          )}

          {errorMsg && <p className="forgot-error">{errorMsg}</p>}
          {message && <p className="forgot-success">{message}</p>}

          <button className="submit" type="submit" disabled={isLoading}>
            {isLoading ? 'Processing...' : resetToken ? 'Update Password' : 'Send Reset Link'}
          </button>
        </form>

        <p className="signin-link">
          Remember your password?{' '}
          <span onClick={() => navigate('/login')}>Sign in</span>
        </p>
      </div>
    </div>
  );
};

export default ForgetPassword;
